<template>
  <b-row class="p-1 bg-white">
    <div class="d-flex col-md-9" v-if="loading.filter">
      <b-skeleton height="40px" width="48%" class="mt-2 mb-2" />
      <b-skeleton height="40px" width="18%" class="mt-2 mb-2 ml-2" />
    </div>
    <filter-swapper v-show="!loading.first" id="employess_swapper" :controlHeightButtons="controlHeight" class="col-md-9">
      <template #slot1>
        <form-render :key="keyFormRender" class="mb-2" :fields="fields" :buttonSend="buttonSend" :form.sync="formFilter"
          @send="filterList" containerButtonsClass="mt-2">
          <template #buttons>
            <b-button
              variant="outline-light"
              v-b-tooltip.hover
              title="Limpiar filtro"
              class="ml-1"
              @click="cleanFilter"
              ><feather-icon icon="RefreshCwIcon"
            /></b-button>
          </template>
        </form-render>
      </template>
    </filter-swapper>
    <div class="col-3 mt-2" style="float: right" v-show="!loading.first">
      <b-button v-can="canCreateEmployee" @click="openModal()" class="push-right" variant="warning">
        {{ $t('Nuevo usuario empleado') }}</b-button>
    </div>
    <div class="col-12 px-0">
      <table-render
        :key="keyTableRender"
        :rows="rows"
        :schema="schema"
        show-empty
        borderless= "borderless"
        class="mx-1"
        v-if="!loading.first"
        :loading="loading.employees"
      >
        <template #receiveStatusChangeTickets="row">
          <feather-icon v-if="row.rowdata.receiveStatusChangeTickets" icon="CheckIcon" class="text-success" />
          <feather-icon v-if="!row.rowdata.receiveStatusChangeTickets" icon="XIcon" class="text-danger" />
        </template>
        <template #receiveLateickets="row">
          <feather-icon v-if="row.rowdata.receiveLateickets" icon="CheckIcon" class="text-success" />
          <feather-icon v-if="!row.rowdata.receiveLateickets" icon="XIcon" class="text-danger" />
        </template>
        <template #ticketStatusChangeReminder="row">
          <feather-icon v-if="row.rowdata.ticketStatusChangeReminder" icon="CheckIcon" class="text-success" />
          <feather-icon v-if="!row.rowdata.ticketStatusChangeReminder" icon="XIcon" class="text-danger" />
        </template>
        <template #ticketLateReminder="row">
          <feather-icon v-if="row.rowdata.ticketLateReminder" icon="CheckIcon" class="text-success" />
          <feather-icon v-if="!row.rowdata.ticketLateReminder" icon="XIcon" class="text-danger" />
        </template>
        <template #externalTicketReminder="row">
          <feather-icon v-if="row.rowdata.externalTicketReminder" icon="CheckIcon" class="text-success" />
          <feather-icon v-if="!row.rowdata.externalTicketReminder" icon="XIcon" class="text-danger" />
        </template>
        <template #actionsBtn="row">
          <b-button variant="flat-primary" v-b-tooltip.hover title="Editar" class="p-0" @click="openModal(row.rowdata.id)"><feather-icon icon="EditIcon" /></b-button>
          <b-button
            v-if="mustBeSeenByWalmart(row.rowdata)"
            variant="flat-danger"
            v-b-tooltip.hover
            title="Desactivar"
            class="p-0"
            @click="confirmDelete(row.rowdata.id)">
            <feather-icon icon="TrashIcon" />
          </b-button>
        </template>
      </table-render>
      <b-skeleton height="40px" width="`calc(100vh - 2.5rem)`" class="mt-1 mb-1" v-if="loading.first" />
      <div class="table-skeleton-tableQuoter" v-if="loading.first">
        <b-skeleton-table
          :rows="pagination.limit || 10"
          :columns="schema.length || 10"
          :table-props="{ }"
        />
      </div>
      <pagination :pagination="pagination" :noDigits="false" :showSize="true" :disabled="loading.employees"/>
    </div>
    <modal-employees
      ref="ModalEmployees"
      :isEdit="isEdit"
      :keyModal="keyModal"
      :employees="employees"
      @getEmployees="getEmployees"
      :roles="roles"
    ></modal-employees>
  </b-row>
</template>
<script>
import { mapGetters } from 'vuex'
import ModalEmployees from './ModalEmployees.vue'
import BaseServices from '@/store/services/index'
import { environment } from '@/environments/environment'

export default {
  name: 'TableEmployedUsers',
  components: { ModalEmployees },
  data () {
    return {
      baseService: new BaseServices(this),
      keyTableRender: 0,
      schema: [],
      rows: [],
      company_id: this.$route.params?.id,
      isEdit: false,
      keyModal: 0,
      loading: {
        employees: false,
        first: true,
        filter: true
      },
      setPermissionModule: {
        module: 'company-details',
        allRoles: true,
        section: 'tab_employees'
      },
      pagination: {
        limit: 10,
        page: 1,
        total: 0,
        loading: false
      },
      selectedRows: [],
      buttons: [],
      buttonSend: {icon: 'SearchIcon', color: 'warning', title: 'Filtrar'},
      controlHeight: { class: 'row mb-2 spacing-label-field'},
      keyFormRender: 0,
      formFilter: {},
      fields: [],
      payloadFilter: {},
      users: [],
      emails: []
    }
  },
  computed: {
    ...mapGetters({
      employees: 'getEmployees',
      // Por temas de tiempo no pudimos realizar la separación de los servicios de empleados
      /* configurationsCompany: 'getConfigurationsCompany',
      selectorsProfiles: 'getSelectorsProfiles', */
      deleteEmployees: 'deleteEmployees',
      generalLoading: 'getLoading',
      roles: 'getRoles',
      mySession: 'getSession'
    }),
    canCreateEmployee () {
      return {permission: 'canCreate', ...this.setPermissionModule}
    }
  },
  watch: {
    employees() {
      this.setEmployees()
    },
    generalLoading: {
      handler () {
        this.loading.employees = !!this.generalLoading.getEmployees
      }
    },
    mySession () {
      this.setPermissionsModule()
    },
    'pagination.page' () {
      this.getEmployees()
    },
    'pagination.limit' () {
      if (this.pagination.page === 1) this.getEmployees()
    }
  },
  mounted () {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      // Por temas de tiempo no pudimos realizar la separación de los servicios de empleados
      /* this.getConfigurationsCompany() */
      this.getRoles()
      this.setSchema()
      this.setFields()
    },
    setSchema() {
      this.schema = [
        {label: 'Nombre', key: 'first_name'},
        {label: 'Apellido', key: 'last_name'},
        {label: 'Correo', key: 'email'},
        {label: 'Tipo de usuario', key: 'userType'},
        {label: 'Teléfono fijo', key: 'phone'},
        {label: 'Celular', key: 'mobile'},
        {label: 'Notificaciones de tickets', icon: 'HelpCircleIcon', text: 'Recibe un email por cada actualizacion de un ticket', key: 'receiveStatusChangeTickets', useSlot: true, class: 'text-center'},
        {label: 'Notificaciones de tickets por atraso', icon: 'HelpCircleIcon', text: 'Recibe un email por cada actualizacion de un ticket abierto por atraso', key: 'receiveLateickets', useSlot: true, class: 'text-center'},
        {label: 'Resumen tickets externos', icon: 'HelpCircleIcon', text: 'Recibe un reporte diario con los tickets abiertos por clientes externos', key: 'externalTicketReminder', useSlot: true, class: 'text-center'},
        {label: 'Resumen tickets', icon: 'HelpCircleIcon', text: 'Recibe un reporte diario con los tickets pendientes de respuesta', key: 'ticketStatusChangeReminder', useSlot: true, class: 'text-center'},
        {label: 'Resumen tickets por atraso', icon: 'HelpCircleIcon', text: 'Recibe un reporte diario con los tickets pendientes de respuesta abiertos por atraso', key: 'ticketLateReminder', useSlot: true, class: 'text-center'}
      ]
      if (this.mySession.id) {
        this.setPermissionsModule()
      }
      this.deleteColumnForWalmart()
    },
    setPermissionsModule() {
      if (this.m_hasPermissionOrFallback({permission: 'canActions', ...this.setPermissionModule}) && !this.schema.some(col => col.key === 'actions')) {
        this.schema.push({label: 'Acciones', key: 'actionsBtn', useSlot: true })
      }
    },
    setEmployees() {
      if (this.employees.rows && this.roles) {
        const company = this.employees.data.company
        const usesProfiles = company?.company_profiles?.uses_profiles ?? false
        const marketplaceUsesProfiles = company?.marketplace_profiles?.uses_profiles ?? false
        const rows = this.employees.rows.map(employee => {
          const userType = usesProfiles || marketplaceUsesProfiles ? 'profile' : 'rol'
          const type = (userType === 'profile') ? Object.values(this.employees.data?.profiles)?.find((userType) => userType.id === employee.profile_id) : Object.values(this.roles || [])?.find((userType) => userType.id === employee.role_id)
          this.getNotifications(employee)
          return {
            id: employee?.id,
            first_name: employee?.first_name || 'Sin info.',
            last_name: employee?.last_name || 'Sin info.',
            email: employee?.email || 'Sin info.',
            userType: type?.name || (userType === 'profile' ? 'No tiene un perfil asignado' : 'No tiene un rol asignado'),
            phone: employee?.phone || 'Sin info.',
            mobile: employee?.mobile || 'Sin info.',
            receiveStatusChangeTickets: !!employee?.receiveStatusChangeTickets,
            receiveLateickets: !!employee?.receiveLateickets,
            ticketStatusChangeReminder: !!employee?.ticketStatusChangeReminder,
            ticketLateReminder: !!employee?.ticketLateReminder,
            externalTicketReminder: !!employee?.externalTicketReminder,
            updatedAt: employee?.updated_at,
            activated: employee?.activated,
            user_deleted_at: employee?.user_deleted_at
          }
        })
        this.rows = rows.sort((a, b) => (new Date(b.updatedAt) || 0) - (new Date(a.updatedAt) || 0))
        this.keyTableRender++
        this.loading.first = false
        this.loading.filter = false
        this.setPagination()
      } else {
        setTimeout(() => {
          this.setEmployees()
        }, 100)
      }
    },
    setPagination() {
      this.pagination.total = this.employees.pagination.total
      this['pagination.limit'] = this.employees.pagination.pages
    },
    setFields () {
      this.fields = [
        { fieldType: 'FieldSelect', label: this.$t('Usuario'), name: 'user_name', allowIdSearch: true, persistSearch: true, searchOnType: { fx: e => this.searchUser(e), nChars: 3, debounce: 600 }, containerClass: 'col-4 col-md-4 container-info', placeholder: 'Ingrese nombre de usuario'},
        { fieldType: 'FieldSelect', label: this.$t('Correo'), name: 'user_email', allowIdSearch: true, persistSearch: true, searchOnType: { fx: e => this.searchEmail(e), nChars: 3, debounce: 600 }, containerClass: 'col-4 col-md-4 container-info', placeholder: 'Ingrese correo de usuario'}
      ]
    },
    getNotifications(employee) {
      if (employee.special_functions) {
        const specialFunctions = JSON.parse(employee.special_functions)
        employee.receiveStatusChangeTickets = specialFunctions.includes('receive-status-change-tickets')
        employee.receiveLateickets = specialFunctions.includes('receive-late-tickets')
        employee.ticketStatusChangeReminder = specialFunctions.includes('ticket_status_change_reminder')
        employee.ticketLateReminder = specialFunctions.includes('ticket_late_reminder')
        employee.externalTicketReminder = specialFunctions.includes('external_ticket_reminder')
      }
    },
    getEmployees() {
      const queryParams = {
        ...this.payloadFilter,
        'page': this.pagination.page,
        'quantity': this.pagination.limit
      }
      this.$store.dispatch('fetchService', { name: 'getEmployees', params: {company_id: this.company_id}, queryParams })
    },
    getRoles() {
      this.$store.dispatch('fetchService', { name: 'getRoles', params: {company_id: this.company_id}, onSuccess: () => this.getEmployees()})
    },
    // Por temas de tiempo no pudimos realizar la separación de los servicios de empleados
    /* getSelectorsProfiles() {
      const queryParams = {
        'company_id': this.company_id
      }
      const params = {company_id: this.company_id}
      this.$store.dispatch('fetchService', { name: 'getSelectorsProfiles', params, queryParams, onSuccess: () => this.getEmployees() })
    },
    getConfigurationsCompany() {
      const queryParams = {
        'company_id': this.company_id
      }
      const params = {company_id: this.company_id}
      this.$store.dispatch('fetchService', { name: 'getConfigurationsCompany', params, queryParams, onSuccess: (resp) => this.handleSelectorsProfiles(resp) })
    },
    handleSelectorsProfiles (resp) {
      const company = resp?.data
      if (company?.company_profiles?.uses_profiles || company?.marketplace_profiles?.uses_profiles) {
        this.getSelectorsProfiles()
      } else {
        this.getEmployees()
      }
    }, */
    openModal(id) {
      this.keyModal++
      this.isEdit = id
      this.$bvModal.show('ModalEmployees')
    },
    confirmDelete(id) {
      this.$yesno(this.$t('msg-pregunta-eliminar-elemento'), () => this.deleteEmployee(id))
    },
    deleteEmployee(id) {
      this.baseService.callService('deleteEmployees', {}, {employee_id: id})
        .then(() => {
          this.$bvToast.toast('Felicitaciones', {
            title: 'Usuario eliminado con éxito',
            variant: 'success',
            autoHideDelay: 2000
          })
          this.getEmployees()
        })
        .catch(err => {
          this.$bvToast.toast(`${err}`, {
            title: 'Ocurrió un problema al eliminar este usuario.',
            variant: 'danger',
            noAutoHide: true
          })
        })
    },
    deleteColumnForWalmart() {
      if ((environment.platformUrl === 'https://platform.enviame.io' &&  this.company_id === '7551') || (environment.platformUrl === 'https://sandbox.enviame.io' &&  this.company_id === '1459')) {
        const keysToRemove = [
          'phone',
          'mobile',
          'receiveStatusChangeTickets',
          'receiveLateickets',
          'externalTicketReminder',
          'ticketStatusChangeReminder',
          'ticketLateReminder',
          'user_deleted_at'
        ]
        this.schema = this.schema.filter(el => !keysToRemove.includes(el.key))
      }
    },
    mustBeSeenByWalmart (data) {
      if ((environment.platformUrl === 'https://platform.enviame.io' &&  this.company_id === '7551') || (environment.platformUrl === 'https://sandbox.enviame.io' &&  this.company_id === '1459')) {
        return [undefined, null].includes(data.user_deleted_at)
      } else {
        return true
      }
    },
    filterList (form) {
      Object.keys(form).map(key => {
        this.payloadFilter['user_id'] = form[key].user_id
      })
      if (this.pagination.page !== 1) this.pagination.page = 1
      else this.getEmployees()
    },
    cleanFilter () {
      this.formFilter = {}
      this.payloadFilter = {}
      this.keyFormRender++
      if (this.pagination.page !== 1) this.pagination.page = 1
      else this.getEmployees()
    },
    searchUser(value) {
      const queryParams = {
        user_name: value
      }
      const params = {company_id: this.company_id}
      return this.baseService.callService('getEmployees', queryParams, params)
        .then(({data}) => {
          const response = data.employees.map(el => ({id: el.id, first_name: el.first_name, last_name: el.last_name, text: `${el.first_name} ${el.last_name}`, user_id: el.user_id}))
          return response
        })
    },
    searchEmail(value) {
      const queryParams = {
        user_email: value
      }
      const params = {company_id: this.company_id}
      return this.baseService.callService('getEmployees', queryParams, params)
        .then(({data}) => {
          const response = data.employees.map(el => ({id: el.id, email: el.email, text: el.email, user_id: el.user_id}))
          return response
        })
    }
  }
}
</script>
